import React, { Component } from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import SignOutButton from '../components/SignOut';
import { AuthUserContext } from './Session';
import Image from 'react-bootstrap/Image'
import img from '../assets/xsell_img1.png'




const Styles = styled.div`
  .navbar {
    background-color: #fff;
  }
  

  a, .navbar-brand, .navbar-nav, .nav-link {
    color: #000;

    &:hover {
      color: rgb(29, 185, 84);
    }
  }
`;

const StyledImage = styled(Image)`
  width: 50px;
  height: 50px;
`;




export default class NavigationBar extends Component {
  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => {
          return authUser ? (
            <Styles>
              <Navbar sticky="top" expand="lg">
                <Navbar.Brand href="/">
                  <StyledImage src={img} roundedCircle />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="ml-auto">
                    {/* <Nav.Item>
                      <Nav.Link>
                        <Link to="/events">Events</Link>
                      </Nav.Link>
                    </Nav.Item> */}
                    <Nav.Item>
                      <Nav.Link>
                        <Link to="/contact">Contact</Link>
                      </Nav.Link>
                    </Nav.Item>
                    {/* <SignOutButton /> */}
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Styles >
          ) : (
              <Styles>
                <Navbar expand="lg">
                  <Navbar.Brand href="/">X-Sell</Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                      <Nav.Item>
                        <Nav.Link>
                          <Link to="/">Home</Link>
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                      <Nav.Link>
                        <Link to="/advertise">Advertise</Link>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link>
                        <Link to="/advertise2">Advertise 2</Link>
                      </Nav.Link>
                    </Nav.Item>

                      {/* <Nav.Item>
                        <Nav.Link>
                          <Link to="/events">Events</Link>
                        </Nav.Link>
                      </Nav.Item> */}
                      <Nav.Item>
                        <Nav.Link>
                          <Link to="/contact">Contact</Link>
                        </Nav.Link>
                      </Nav.Item>
                      {/* <SignOutButton /> */}
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </Styles >
            )
        }
        }
      </AuthUserContext.Consumer>
    )
  }
}


